module.exports = __webpack_public_path__ + "img/radiochoose.22e2bac1.svg";